import 'protons';
import './_user-login.scss';
import './_user-login.twig';

export const name = 'user-login';

export const defaults = {};

export function disable() {}

export function enable() {
  const userLogin = document.querySelector('.user-login__mobiltab-login');
  const docchecklogin = document.querySelector(
    '.user-login__mobiltab-doccheck'
  );
  const userLoginContainer = document.querySelector('.user-login__accordlogin');
  const doccheckLoginContainer = document.querySelector(
    '.user-login__docchecklogin'
  );
  if (userLogin) {
    userLogin.addEventListener('click', () => {
      userLogin.style.opacity = '1';
      docchecklogin.style.opacity = '';
      userLoginContainer.style.display = 'block';
      doccheckLoginContainer.style.display = 'none';
    });
  }
  if (docchecklogin) {
    docchecklogin.addEventListener('click', () => {
      userLogin.style.opacity = '0.6';
      docchecklogin.style.opacity = '1';
      doccheckLoginContainer.style.display = 'block';
      userLoginContainer.style.display = 'none';
    });
  }
}

export default enable;
